import AwardRfq from '../../../../../../client/src/rfq/src/viewmodel/AwardRfqViewModel';
import { DesBaseRfqIdRfqQuoteId } from '../utils/des-base-rfqId-quoteId-acc';

export default class DesAwardRfq extends DesBaseRfqIdRfqQuoteId {

    constructor() {
        console.log('DesAwardRfq invoked');
        super(AwardRfq);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfqIdRfqQuoteId.observedAttributes];
    }
}
if (!window.customElements.get('des-award-rfq')) {
    window.customElements.define('des-award-rfq', DesAwardRfq);
}
